// a little function to help us with reordering the result
export function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
// Gets a number from % or px, considering layoutItem's scale
export const valueFromString = (value, size, scale, valueIfNaN = 0) => {
    // @ts-ignore
    if (value === "auto")
        return "auto";
    if (value === "")
        return 0;
    if (typeof value === "number")
        return value;
    if (value.endsWith("%")) {
        const result = (parseFloat(value.substring(0, value.length - 1)) * size) / 100 / scale;
        return isNaN(result) ? valueIfNaN : result;
    }
    else if (value.endsWith("px")) {
        const result = parseFloat(value.substring(0, value.length - 2)) / scale;
        return isNaN(result) ? valueIfNaN : result;
    }
    const result = parseFloat(value) / scale;
    return isNaN(result) ? valueIfNaN : result;
};
export const pxToPercents = (value, size) => {
    if (value === "auto")
        return "auto";
    let formattedValue = parseInt(value);
    if (value.endsWith("px")) {
        formattedValue = parseFloat(value.substring(0, value.length - 2));
    }
    return `${Math.round((formattedValue / size) * 100).toString()}%`;
};
export const percentsToPx = (value, size) => {
    if (value === "auto")
        return "auto";
    return `${Math.round((parseFloat(value.substring(0, value.length - 1)) * size) / 100)}px`;
};
export const getWidgetResize = ({ isSelected, isLocked, resize, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!isSelected || isLocked) {
        return false;
    }
    if (typeof resize === "boolean")
        return resize;
    return {
        bottom: (_a = resize === null || resize === void 0 ? void 0 : resize.bottom) !== null && _a !== void 0 ? _a : true,
        bottomLeft: (_b = resize === null || resize === void 0 ? void 0 : resize.bottomLeft) !== null && _b !== void 0 ? _b : true,
        bottomRight: (_c = resize === null || resize === void 0 ? void 0 : resize.bottomRight) !== null && _c !== void 0 ? _c : true,
        left: (_d = resize === null || resize === void 0 ? void 0 : resize.left) !== null && _d !== void 0 ? _d : true,
        right: (_e = resize === null || resize === void 0 ? void 0 : resize.right) !== null && _e !== void 0 ? _e : true,
        top: (_f = resize === null || resize === void 0 ? void 0 : resize.top) !== null && _f !== void 0 ? _f : true,
        topLeft: (_g = resize === null || resize === void 0 ? void 0 : resize.topLeft) !== null && _g !== void 0 ? _g : true,
        topRight: (_h = resize === null || resize === void 0 ? void 0 : resize.topRight) !== null && _h !== void 0 ? _h : true,
    };
};
export const valueToString = (value, size) => {
    if (size === 0) {
        return "0%";
    }
    return `${Math.round((value / size) * 100)}%`;
};
export const duplicateItemCoordinates = ({ x, y, }) => {
    let newX = x;
    let newY = y;
    if (x.endsWith("%")) {
        newX = `${parseFloat(x) + 2}%`;
    }
    else if (x.endsWith("px")) {
        newX = `${parseFloat(x.substring(0, x.length - 2)) + 20}px`;
    }
    else {
        newX = x + 20;
    }
    if (y.endsWith("%")) {
        newY = `${parseFloat(y) + 2}%`;
    }
    else if (y.endsWith("px")) {
        newY = `${parseFloat(y.substring(0, y.length - 2)) + 20}px`;
    }
    else {
        newY = y + 20;
    }
    return {
        x: newX,
        y: newY,
    };
};
export const widgetsWithAnimations = ["text", "clock"];
export const scaleDirs = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
export const updateWithPx = ({ direction, layoutItem, layoutService, rndScale, position, ref, }) => {
    const newLayoutItem = {
        ...layoutItem,
        width: `${Math.round(ref.offsetWidth)}px`,
        height: `${Math.round(ref.offsetHeight)}px`,
        x: `${Math.round(position.x)}px`,
        y: `${Math.round(position.y)}px`,
        scale: rndScale,
    };
    layoutService.updateLayoutItem(newLayoutItem);
};
export const updateWithPercents = ({ direction, layoutItem, layoutService, rndScale, position, ref, screenHeight, screenWidth, }) => {
    const newLayoutItem = {
        ...layoutItem,
        width: pxToPercents(ref.offsetWidth.toString(), screenWidth),
        height: pxToPercents(ref.offsetHeight.toString(), screenHeight),
        x: pxToPercents(position.x.toString(), screenWidth),
        y: pxToPercents(position.y.toString(), screenHeight),
        scale: rndScale,
    };
    layoutService.updateLayoutItem(newLayoutItem);
};
